export const AppEventFired = "APP_EVENT_FIRED";
